import { CalendarDate } from '@internationalized/date';

export type CalendarQuarterSelection = {
  quarter: number;
  year: number;
};

export type CalendarFocusedValueInput = {
  selectedDate?: CalendarDate;
  startMonth: number | null;
  startMonthYear: number | null;
  startQuarter: CalendarQuarterSelection | null;
};

/** First day of a fiscal quarter (aligned with getQuarterDates in Calendar/index). */
function getQuarterStartCalendarDate(
  year: number,
  quarter: number
): CalendarDate {
  switch (quarter) {
    case 1:
      return new CalendarDate(year - 1, 12, 1);
    case 2:
      return new CalendarDate(year, 3, 1);
    case 3:
      return new CalendarDate(year, 6, 1);
    case 4:
      return new CalendarDate(year, 9, 1);
    default:
      return new CalendarDate(year - 1, 12, 1);
  }
}

/**
 * Visible month for single-mode Spectrum Calendar (not RangeCalendar).
 * Uses the selected day, else day 1 of the selected month/quarter, else today.
 */
export function getCalendarFocusedValue({
  selectedDate,
  startMonth,
  startMonthYear,
  startQuarter
}: CalendarFocusedValueInput): CalendarDate {
  if (selectedDate) {
    return selectedDate;
  }

  if (startMonth != null && startMonthYear != null) {
    // startMonth is 0-indexed (Date.getMonth); CalendarDate month is 1-indexed
    return new CalendarDate(startMonthYear, startMonth + 1, 1);
  }

  if (startQuarter) {
    return getQuarterStartCalendarDate(startQuarter.year, startQuarter.quarter);
  }

  const now = new Date();
  return new CalendarDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
}
